import React from "react";
import { LayoutDashboard, BarChart3, Users, History } from "lucide-react";

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "reports", label: "Reports", icon: BarChart3 },
  { id: "users", label: "Users", icon: Users },
];

const Sidebar = ({ history = [], activeId, onSelectHistory, theme = "light", isOpen = true }) => {
  const isDark = theme === "dark";
  return (
    <aside
      className={`fixed left-0 top-0 flex h-screen w-64 flex-col border-r transition-transform duration-300 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}
    >
      <div className="px-6 pt-6">
        <img
          src="https://www.staging2.ahk-prod.com/img/logo-1756793595.jpg"
          alt="Company logo"
          className="h-10 w-auto object-contain"
        />
      </div>
      <nav className="mt-4 hidden space-y-1 px-4">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive = index === 0;
          return (
            <div
              key={item.id}
              className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium transition ${
                isActive
                  ? "bg-[#7e6ff5]/10 text-[#7e6ff5]"
                  : isDark
                  ? "text-slate-300 hover:bg-slate-800"
                  : "text-slate-600 hover:bg-slate-50"
              }`}
            >
              <Icon size={18} />
              {item.label}
            </div>
          );
        })}
      </nav>
      <div className="mt-8 flex flex-1 flex-col overflow-hidden px-4 pb-6">
        <div className={`flex items-center justify-between px-2 text-xs font-semibold uppercase tracking-widest ${
          isDark ? "text-slate-500" : "text-slate-400"
        }`}>
          Recent Requests
          <History size={14} />
        </div>
        <div className="sidebar-scroll mt-3 flex-1 space-y-2 overflow-y-auto pr-1">
          {history.length === 0 && (
            <div className={`rounded-xl border border-dashed p-3 text-xs ${
              isDark ? "border-slate-800 text-slate-500" : "border-slate-200 text-slate-400"
            }`}>
              No recent queries yet.
            </div>
          )}
          {history.slice(0, 10).map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelectHistory(item)}
              className={`w-full rounded-xl border px-3 py-2 text-left text-xs transition ${
              isDark
                ? activeId === item.id
                  ? "border-slate-700 border-b-4 border-b-violet-500 bg-slate-600 text-white hover:bg-slate-700"
                  : "border-transparent bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                : activeId === item.id
                ? "border-transparent border-b-4 border-b-[#323665] bg-[#DCE4F0] text-[#000000] hover:bg-[#323665] hover:text-white"
                : "border-transparent bg-[#F5F7FA] text-[#323665] hover:bg-[#323665] hover:text-white"
              }`}
              title={item.user_prompt}
            >
              <div className="line-clamp-2">{item.user_prompt}</div>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
